const cartDataKey = 'pasaroa-cart';

function setData(data) {
	localStorage.setItem(cartDataKey, JSON.stringify(data));
}

function getCartData() {
	const cartData = localStorage.getItem(cartDataKey);

	if (cartData) {
		const data = JSON.parse(cartData);

		return data;
	}

	return null;
}

function clearData() {
	localStorage.removeItem(cartDataKey);
}

export default {
	setData,
	getCartData,
	clearData,
};